import { render, staticRenderFns } from "./LegalPersonBusinessAmendments.vue?vue&type=template&id=1eff71e4&scoped=true&"
import script from "./LegalPersonBusinessAmendments.vue?vue&type=script&lang=js&"
export * from "./LegalPersonBusinessAmendments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff71e4",
  null
  
)

export default component.exports